import _typeof from "@babel/runtime/helpers/typeof";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import * as MuiIcons from '@material-ui/icons';

var _default = function _default(icon) {
  var fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 80;
  var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var style = {
    fontSize: fontSize
  };

  if (color) {
    style.color = color;
  } // Find the mui icon by name if string


  if (typeof icon === 'string') {
    var MuiIcon = icon && MuiIcons[icon];
    return /*#__PURE__*/React.createElement(MuiIcon, {
      style: style
    });
  } // Use custom icon


  if (_typeof(icon) === 'object') {
    var CustomIcon = icon.component,
        _icon$color = icon.color,
        _color = _icon$color === void 0 ? 'currentColor' : _icon$color;

    var props = {
      fill: _color,
      stroke: _color
    };
    return /*#__PURE__*/React.createElement(CustomIcon, {
      style: props
    });
  }

  return icon;
};

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/platform/core/src/utils/getIcon.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();